import React, { useEffect } from "react";
import CommonPopup from "..";
import { NearBuildingServiceType } from "../../../services/buildingServices";

import useGPS from "../../../hooks/useGPS";
import { useDeviceType } from "../../../hooks/useDeviceType/Index";

import FindBuilding from "../../Building/Find";
import { Reason } from "../../../types/location";

type Props = {
  popup: string;
  onClose: () => void;
  onChangeBuilding: (building: any) => void;
  type?: NearBuildingServiceType;
  reason: Reason
};

export default function FindBuildingPopup({
  popup,
  onClose,
  onChangeBuilding,
  type,
  reason
}: Props) {
  const deviceType = useDeviceType();
  const [gpsResult, callGps] = useGPS({
    isDesktop: deviceType === "unknown",
  });

  useEffect(() => {
    callGps();
  }, []);

  return (
    <CommonPopup
      title="건물 변경"
      isOpen={popup === "selectBuilding"}
      onClose={onClose}
      padding={0}
      unUseHorizonRule
    >
      <FindBuilding
        onChange={onChangeBuilding}
        onClose={onClose}
        coordinate={gpsResult.result}
        onCallback={callGps}
        type={type}
        reason={reason}
      />
    </CommonPopup>
  );
}
